import React from 'react';

function Home() {
  return (
    <div className="h-container">
      <h1 className="h-h1">Welcome to My Webpage</h1>
      <p className="h-para">
        Math Magician is an app that allows clients to perform
        mathmetical operations and motivate them at the same time
        by displaying random math quotes
      </p>
    </div>
  );
}
export default Home;
